import { translate } from '@utils/i18n';
import RushCell from './components/RushCell';
import KitNumberCell from './components/KitNumberCell';
import StatusActionCell from './components/StatusActionCell';
import BuildingNameCell from './components/BuildingNameCell';
export const CACHE_KEY = 'kendo/sprinkler_sampling/index';
export const NAMESPACE = 'buildings.tabs.sprinkler_sampling';
export const KIT_ORDERS_NAMESPACE = 'analytic_reports.sprinkler_projection_report';
export const KIT_ORDERS_CACHE_KEY = 'kendo/kit_orders/index';
export const KIT_ORDER_STATUS = {
    PENDING: 'pending',
    COMPLETED: 'completed'
};
export const INITIAL_KIT_ORDER_FILTERS = {
    active: {
        orderDate: true,
        user: true,
        status: true
    },
    values: {
        orderDate: { rangeType: '', startDate: '', endDate: '' },
        user: [],
        status: ''
    },
    operators: {}
};
export const MAX_SPRINKLER_LOCATIONS_DYNE_KIT = 8;
export const MAX_SPRINKLER_LOCATIONS_UNLIMITED = 999;
export const MAX_SPRINKLER_LOCATION_LENGTH = 128;
export const SUBMISSION_STATUS = {
    SENT: 'sent',
    COMPLETED: 'completed'
};
export const DYNE_CONTACT = {
    phone: '800-632-2304',
    email: 'dyne.lab@nfpaglobal.com'
};
export const ENVIRONMENT_TYPE_OPTIONS = [
    {
        value: 'standard',
        label: translate('form.environment_types.standard', { namespace: NAMESPACE })
    },
    {
        value: 'harsh_environment',
        label: translate('form.environment_types.harsh_environment', { namespace: NAMESPACE })
    },
    {
        value: 'dwelling_unit',
        label: translate('form.environment_types.dwelling_unit', { namespace: NAMESPACE })
    }
];
export const PACKAGING_TYPE = {
    DYNE_KIT: 'dyne_kit',
    CUSTOMER_SUPPLIED_BOX: 'customer_supplied_box'
};
export const PACKAGING_TYPE_OPTIONS = [
    {
        value: PACKAGING_TYPE.DYNE_KIT,
        label: translate('form.packaging_types.dyne_kit', { namespace: NAMESPACE })
    },
    {
        value: PACKAGING_TYPE.CUSTOMER_SUPPLIED_BOX,
        label: translate('form.packaging_types.customer_supplied_box', { namespace: NAMESPACE })
    }
];
export const INITIAL_FILTERS = {
    values: {
        kitNumber: '',
        priority: '',
        status: '',
        submittedAt: {
            rangeType: '',
            startDate: '',
            endDate: ''
        }
    },
    active: {
        kitNumber: true,
        priority: true,
        submittedAt: true,
        status: true
    },
    operators: { kitNumber: 'contains' }
};
export const ALL_COLUMNS = [
    'kitNumber',
    'jobName',
    'sampleArea',
    'sampleCount',
    'rush',
    'samplesTakenBy',
    'submissionSentBy',
    'submittedAt',
    'statusAction'
];
// Additional columns shown only when the table is rendered cross-building (no buildingId).
export const LOCATION_COLUMNS = ['buildingName', 'territoryName'];
export const COLUMNS_DATA = {
    kitNumber: {
        id: 'kitNumber',
        field: 'kitNumber',
        sortable: true,
        title: translate('columns.kit_number', { namespace: NAMESPACE }),
        cell: KitNumberCell
    },
    jobName: {
        id: 'jobName',
        sortable: true,
        field: 'jobName',
        title: translate('columns.job_name', { namespace: NAMESPACE })
    },
    sampleArea: {
        id: 'sampleArea',
        field: 'sampleArea',
        sortable: true,
        title: translate('columns.sample_area', { namespace: NAMESPACE })
    },
    sampleCount: {
        id: 'sampleCount',
        field: 'sampleCount',
        sortable: true,
        title: translate('columns.sample_count', { namespace: NAMESPACE }),
        type: 'number',
        width: 120
    },
    rush: {
        id: 'rush',
        field: 'rush',
        sortable: true,
        title: translate('columns.rush', { namespace: NAMESPACE }),
        cell: RushCell,
        width: 100
    },
    samplesTakenBy: {
        id: 'samplesTakenBy',
        field: 'samplesTakenBy',
        sortable: true,
        title: translate('columns.samples_taken_by', { namespace: NAMESPACE })
    },
    submissionSentBy: {
        id: 'submissionSentBy',
        field: 'submissionSentBy',
        sortable: false,
        title: translate('columns.submission_sent_by', { namespace: NAMESPACE })
    },
    submittedAt: {
        id: 'submittedAt',
        field: 'submittedAt',
        sortable: true,
        title: translate('columns.submitted_at', { namespace: NAMESPACE })
    },
    statusAction: {
        id: 'statusAction',
        field: 'statusAction',
        sortable: false,
        title: translate('columns.actions', { namespace: NAMESPACE }),
        cell: StatusActionCell
    },
    buildingName: {
        id: 'buildingName',
        field: 'buildingName',
        sortable: false,
        title: translate('columns.building', { namespace: NAMESPACE, defaultValue: 'Building' }),
        cell: BuildingNameCell
    },
    territoryName: {
        id: 'territoryName',
        field: 'territoryName',
        sortable: false,
        title: translate('columns.territory', { namespace: NAMESPACE, defaultValue: 'Territory' })
    }
};
